import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateIfollowedUpTodo } from 'src/redux/services/loggingServices';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { Logger } from 'src/latest/src/services';
import AppButton from 'src/components/base/Button/Button';
import { LoadingIndicator, Todo, TodoTypeEnums } from 'src/latest/src';
import { bookingStatus } from 'src/api/user';
import MeetingInfoCard from 'src/latest/src/components/MeetingInfoCard/MeetingInfoCard';
import { MeetingInformation } from 'src/latest/src/types/MeetingInformation';
import './ConfirmAppointmentTodo.scss';
import { Typography } from 'src/latest/src/components';

type Props = {
  todo: Todo;
  onConfirm: () => void;
};

const ConfirmAppointmentTodo = ({ todo, onConfirm }: Props) => {
  const [acceptingInProgress, setAcceptingInProgress] = useState(false);
  const [rejectingInProgresss, setRejectingInProgresss] = useState(false);
  const [loading, setLoading] = useState(true);
  const [meetingInformation, setMeetingInformation] =
    useState<MeetingInformation>();
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const dispatch = useDispatch();

  useEffect(() => {
    getMeetingInformation();
  }, []);

  const confirmTODO = async (status: boolean) => {
    const reqObj = {
      follow_up_by: ['EMAIL'],
      note: ``,
      action_metadata: {
        appointment_confirmed: status,
      },
    };

    status ? setAcceptingInProgress(true) : setRejectingInProgresss(true);

    try {
      await updateIfollowedUpTodo(todo.id, reqObj);
      dispatch(clearModalContent());
      onConfirm();
      status ? setAcceptingInProgress(false) : setRejectingInProgresss(false);
    } catch (e) {
      status ? setAcceptingInProgress(false) : setRejectingInProgresss(false);
      Logger.error('Confirm TODO error', e);
    }
  };

  const getMeetingInformation = async () => {
    try {
      setLoading(true);

      const uniqueId =
        todo.type === TodoTypeEnums.PROVIDER_APPOINTMENT_CONFIRMATION_TODO
          ? (todo?.metadata as any)?.client_id
          : todo?.user_id;

      const result = await bookingStatus(uniqueId, 'large');

      setMeetingInformation(result);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <div className="confirm-appointment-todo-container">
      <div>
        <b>
          {todo.type === TodoTypeEnums.PROVIDER_APPOINTMENT_CONFIRMATION_TODO
            ? (todo?.metadata as any)?.client_name
            : todo?.user_full_name}
        </b>{' '}
        has requested an appointment with <b>{todo?.provider_full_name}</b>
      </div>

      <div>
        <LoadingIndicator className="mt-5" loading={loading} />
        {!loading && (
          <>
            {meetingInformation ? (
              <MeetingInfoCard meetingInformation={meetingInformation} />
            ) : (
              <Typography
                variant="size-12"
                color="color-19"
                weight="semi-bold"
                className="clients-list__clients d-inline-block ms-1"
              >
                No appointment details found
              </Typography>
            )}
          </>
        )}
      </div>
      <div className="text-center">
        <Typography variant="size-18" className="footer1-text">
          This TO-DO will be automatically cleared if and when the provider
          responds by email. If needed it can also be manually cleared here.
        </Typography>
      </div>
      <div className="form-check mt-5">
        <input
          type="checkbox"
          id="confirm-checkbox"
          className="form-check-input mb-4"
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
        <label htmlFor="confirm-checkbox" className="form-check-label">
          <Typography
            variant="size-14"
            className={!isChecked ? 'color-grey' : ''}
          >
            I know the provider’s availability and will clear this TODO instead
            of the provider
          </Typography>
        </label>
      </div>

      <div className="buttons mt-5 d-flex justify-content-around">
        <AppButton
          label="Confirm Request"
          disabled={
            !isChecked || loading || rejectingInProgresss || acceptingInProgress
          }
          isProcessing={acceptingInProgress}
          className="confirm-btn"
          onClick={() => {
            confirmTODO(true);
          }}
        />
        <AppButton
          disabled={
            !isChecked || loading || rejectingInProgresss || acceptingInProgress
          }
          isProcessing={rejectingInProgresss}
          variant="danger"
          className="cancel-btn"
          label="Cancel Request"
          onClick={() => {
            confirmTODO(false);
          }}
        />
      </div>
    </div>
  );
};

export default ConfirmAppointmentTodo;
